import { connect } from 'react-redux';
import { placeCollectOrder, setCollectError } from 'Favourites/store/actions';
import { selectProducts } from 'Favourites/store/reducers/data/products';
import { selectIsFormProcessing } from 'Favourites/store/reducers';

import {
    selectNoStoresAvailable,
    selectSelectedStoreId,
    selectError,
} from 'store/reducers/data/clickCollect';

import * as forms from 'Favourites/store/constants/formTypes';

const mapStateToProps = (state) => {
    return {
        noStoresAvailable: selectNoStoresAvailable(state),
        selectedStore: selectSelectedStoreId(state),
        products: selectProducts(state),
        error: selectError(state),
        processing: selectIsFormProcessing(state, forms.ClickCollect),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        placeCollectOrder: (store, products) => {
            dispatch(setCollectError(''));
            dispatch(placeCollectOrder(store, products));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
